export enum ROUTE_MEMBERS {
  members = '/members',
  addMember = '/members/add-member',
  editMember = '/members/:userId/edit',
}
